import type { ReactNode } from "react";
import { Skeleton } from "@repo/ui/components/ui/skeleton";
import { Separator } from "@repo/ui/components/ui/separator";

/**
 * Pezzi di markup condivisi fra la pagina e il suo `loading.tsx`, così lo
 * skeleton mostrato durante lo streaming è identico a quello della pagina e
 * non c'è salto di layout quando arrivano i dati.
 */

export const BRAND_GRID =
  "grid grid-cols-4 md:grid-cols-5 lg:grid-cols-6 max-md:grid-cols-2 gap-x-6 gap-y-3";

export const BRAND_ARTICLE = "m-[-40px] max-md:m-[-20px] flex flex-col";

export function BrandsHeader({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle: string;
  children?: ReactNode;
}) {
  return (
    <header className="px-10 py-16 max-md:px-6 max-md:py-10 linear-gradient">
      <h1 className="text-6xl max-md:text-3xl font-bold mb-4">{title}</h1>
      <p className="text-xl max-md:text-base text-secondary-black/70 dark:text-primary-dustyWhite max-w-2xl">
        {subtitle}
      </p>
      {children}
    </header>
  );
}

export function BrandsSkeleton() {
  return (
    <div className="px-10 py-12 max-md:px-6 max-md:py-8 flex flex-col gap-10">
      {[0, 1, 2].map((i) => (
        <div key={i} className="flex flex-col gap-4">
          <Skeleton className="h-10 w-16" />
          <Separator />
          <div className={BRAND_GRID}>
            {Array.from({ length: 10 }).map((_, j) => (
              <Skeleton key={j} className="h-5 w-full" />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
